import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Check } from '../../../svg/Check.svg';

const Leg3DWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1.5px solid transparent;
  cursor: pointer;
  background: #f6f6f6;
  position: relative;
  padding: 4px 14px 4px 14px;
  border-radius: 20px;
  &.active {
    border: 1.5px dotted #ccc;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 4px 14px 4px 14px;
  }
`;

const Leg3DText = styled('span')`
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin-left: 2px;
  &.active {
  }
`;

const Leg3DCheckmark = styled('div')`
  background: #fff;
  padding: 3px;
  border-radius: 999px;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  display: none;
  &.active {
    display: flex;
    margin-left: -6px;
  }
  svg {
    path {
      fill: #000;
    }
  }
`;

export const Leg3D = (props) => {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <Leg3DWrapper
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className={`${hovered || props.active ? 'active' : ''}`}
        onClick={props.onClick}
        active={props.active}
      >
        <Leg3DCheckmark className={`${props.active ? 'active' : ''}`}>
          <Check></Check>
        </Leg3DCheckmark>
        <Leg3DText className={`${hovered || props.active ? 'active' : ''}`}>
          {props.leg.publicName ? props.leg.publicName : props.leg.name}
        </Leg3DText>
      </Leg3DWrapper>
    </>
  );
};
